import { render, staticRenderFns } from "./Logowanie.vue?vue&type=template&id=1bfc7924&"
import script from "./Logowanie.vue?vue&type=script&lang=js&"
export * from "./Logowanie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports